import React from 'react';

import { LottieLoaderHolder, LottieLoaderComponent } from "./LottieLoader.styles";

interface LottieLoaderProps {
    show: boolean;
}

const LottieLoader = ({ show }: LottieLoaderProps) => {
    return (
        <LottieLoaderHolder show={show}>
            <LottieLoaderComponent />
        </LottieLoaderHolder>
    )
}

export default LottieLoader;
